import { Inbox } from '@mui/icons-material';
import React from 'react';

import { ServiceSectionProps } from './ServiceSection.props';
import { SwipeableServiceCard } from '../../components/SwipeableServiceCard';
import {
  EmptyStateContainer,
  EmptyStateText,
  SectionHeader,
  SectionTitle,
  SectionCount,
} from '../../MobileServices.styles';

export const ServiceSection: React.FC<ServiceSectionProps> = ({
  title,
  services,
  emptyMessage,
  currentUserName,
  onCardClick,
}) => (
  <>
    <SectionHeader>
      <SectionTitle>
        {title}
        <SectionCount>{services.length}</SectionCount>
      </SectionTitle>
    </SectionHeader>
    {services.length === 0 ? (
      <EmptyStateContainer>
        <Inbox fontSize="large" />
        <EmptyStateText>{emptyMessage}</EmptyStateText>
      </EmptyStateContainer>
    ) : (
      services.map((s) => (
        <SwipeableServiceCard
          key={s.id}
          service={s}
          currentUserName={currentUserName}
          onClick={() => onCardClick(s.serviceId, s.logoPic)}
        />
      ))
    )}
  </>
);
